import { render } from "./Quotation2.vue?vue&type=template&id=6914eeb3"
import script from "./Quotation2.vue?vue&type=script&lang=js"
export * from "./Quotation2.vue?vue&type=script&lang=js"
script.render = render

export default script